import braintree from "braintree-web";

Alpine.data('SevenBraintreeDataCollectorDeviceData', (element) => ({
    value: '',

    async init() {
        document.addEventListener("braintree:client:init", async (event) => {
            const {client} = event.detail;
            const instance = await braintree.dataCollector.create({
                client,
                version: 2
            });

            const data = await instance.getDeviceData({raw: true});
            this.value = data.correlation_id;
        });
    },

}));


